let checkboxID = 0;

export function getNextCheckboxID()
{
    return checkboxID++;
}